// extracted by mini-css-extract-plugin
export var searchHeader = "_an-0";
export var searchHeaderDark = "_an-1";